import React from "react";

export default function AssessmentsPlanFollowUp({ data, onChange }) {
  const set = (k, v) => onChange({ ...data, [k]: v });
  return (
    <div className="cn-card">
      <h3>Assessments / Plan of Care / Follow Up</h3>
      <label>Assessments</label>
      <textarea rows={2} value={data.assessments} onChange={(e)=>set("assessments", e.target.value)} />
      <label>Treatment / Plan of Care</label>
      <textarea rows={2} value={data.treatment} onChange={(e)=>set("treatment", e.target.value)} />
      <label>Follow Up</label>
      <textarea rows={2} value={data.followUp} onChange={(e)=>set("followUp", e.target.value)} />
    </div>
  );
}
